import type { CardRatingBucketDto } from '@lunary/api-client'
import { REACTIONS } from '@lunary/ui-web/reactions'
import { HBars } from '../../shared/ui/charts/hbars'
import { Kpi } from '../../shared/ui/charts/kpi'
import { formatNumber } from '../../shared/ui/charts/scale'
import styles from '../overview/overview.module.css'

export function formatAverage(value: number | null): string {
  return value === null ? '—' : value.toFixed(2).replace('.', ',')
}

export function BucketSection({ id, title, bucket }: { id: string; title: string; bucket: CardRatingBucketDto }) {
  return (
    <section className={styles.section} aria-labelledby={id}>
      <h2 id={id}>{title}</h2>
      <div className={styles.kpis}>
        <Kpi label="Реакций" value={formatNumber(bucket.total)} />
        <Kpi label="Средняя из 5" value={formatAverage(bucket.average)} />
      </div>
      {bucket.total === 0 ? (
        <p className="muted">За период реакций пока нет.</p>
      ) : (
        <div>
          <div className="card-panel">
            <p className={styles.caption}>Как отозвалась карта</p>
            <HBars
              label={`${title}: реакции`}
              color="var(--accent)"
              items={REACTIONS.map((item) => ({
                key: String(item.value),
                label: `${item.emoji} ${item.label}`,
                value: bucket.counts[item.value - 1] ?? 0,
              }))}
            />
          </div>
        </div>
      )}
    </section>
  )
}
